import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { ClientAgreementDocumentBO, SendToUserBO, SubmitClientAggremntBo } from './files/files.model';
import { GlobalComponent } from 'src/app/global/global.component';

@Injectable({
  providedIn: 'root'
})

export class clientOnboardingService {
  constructor(private http: HttpClient, public errorService: ErrorService, public global : GlobalComponent) { }

  gettype(paramsData: URLSearchParams): Observable<[{ Key: string, Value: string }]> {
    let url = "api/Lov/getLovDropDown?";
    return this.http.get<[{ Key: string, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetClientDetailsAgency(params: URLSearchParams): Observable<any> {
    let url;
    if(this.global.OnboardingLoginType =='onboardLogin')
      {
        url = "api/Client_ServiceDeliveryPlan/GetClientDetails?";
     }
     else{

        url = "api/ClientAgreement/GetClientDetails?";
      }
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetClientDetailsportal(): Observable<any> {
    let url = "api/Client_ClientAgreement/GetClientbyClientId?"
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetClientDocumentForAgency(params: URLSearchParams): Observable<any> {
    let url = "api/ClientAgreement/GetClientDocumentForAgency?"
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetClientDocumentForPortal(params: URLSearchParams): Observable<any> {
    let url = "api/Client_ClientAgreement/GetClientDocumentForPortal?"
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getpdf(params: URLSearchParams): Observable<any> {
    let url = "api/ClientAgreement/GetClientDocumentPdfDetails?"
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetAgencyClientTemplateDetails(params: URLSearchParams): Observable<any> {
    let url = "api/ClientAgreement/GetAgencyClientTemplateDetails?"
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  COMPLETE(list): Observable<any> {
    let url = "api/ClientAgreement/ClientAgreementCompleteDocument";
    return this.http.post<any>(url, list, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError))
  }

  SaveClientDocumentForAgency(saveDocument: ClientAgreementDocumentBO): Observable<any> {
    let url = "api/ClientAgreement/SaveClientDocumentForAgency";
    return this.http.post<any>(url, saveDocument, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  SaveClientDocumentForPortal(saveDocument: ClientAgreementDocumentBO): Observable<any> {
    let url = "api/Client_ClientAgreement/SaveClientDocumentForPortal";
    return this.http.post<any>(url, saveDocument, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  savesubmit(saveDocument: ClientAgreementDocumentBO): Observable<any> {
    let url = "api/Client_ClientAgreement/SaveSubmitClientDocumentForPortal";
    return this.http.post<any>(url, saveDocument, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  SendToClient(note: SendToUserBO): Observable<any> {
    let url = "api/Client/sendToClient";
    return this.http.post<any>(url, note, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  submitClientDocPortal(agreementBo: SubmitClientAggremntBo): Observable<any> {
    let url = "api/Client_ClientAgreement/submitClientDocPortalforEmployee";
    return this.http.post(url, agreementBo, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

}